type Props = {
  name?: string;
  emoji?: string;
  size?: number;
  className?: string;
};

const DEFAULT_EMOJI = "🐋";

export function SpeakerAgentAvatar({
  name = "Whale",
  emoji = DEFAULT_EMOJI,
  size = 20,
  className = "",
}: Props) {
  return (
    <span
      className={`surf-speaker-agent-avatar${className ? ` ${className}` : ""}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.72) }}
      title={name}
      aria-hidden
    >
      {emoji}
    </span>
  );
}
